module.exports = __webpack_public_path__ + "static/media/slider_2.8271b036.jpg";